import { CustomGridColDef } from 'components/table/Table/types';

export const COLUMNS: CustomGridColDef[] = [
  {
    field: 'jamfAssetId',
    headerName: 'Jamf Asset ID',
    width: 200,
    flex: 1,
    cellType: 'text-cell',
    sortable: false,
  },
  {
    field: 'allwhereAssetNumber',
    headerName: 'allwhere Asset #',
    width: 200,
    flex: 1,
    cellType: 'link-cell',
    sortable: false,
  },
  {
    field: 'serialNumber',
    headerName: 'Serial Number',
    width: 200,
    flex: 1,
    cellType: 'text-cell',
    sortable: false,
  },
  {
    field: 'make',
    headerName: 'Make',
    width: 200,
    flex: 1,
    cellType: 'text-cell',
    sortable: false,
  },
  {
    field: 'model',
    headerName: 'Model',
    width: 200,
    flex: 1,
    cellType: 'text-cell',
    sortable: false,
  },
]; 
